<ng-container *transloco="let convert;">
  <form data-test-id="address-change-form-container" class="form" (ngSubmit)="submit()">
    <div class="address-body">
      <div class="input-wrapper col-sm-12 col-md-6 col-lg-6">
        @if (address) {
          <form data-test-id="address-change-form" name="editPhoneNumber" class="form" [formGroup]="addressForm">
            <div class="form-group">
              <div class="form-group w-100 me-5">
                @if (isTitle) {
                  <label data-test-id="address-change-form-name-label"
                  for="primary_phone">{{convert('profileManagement.addressChangeForm.textTitleName')}}</label>
                }
                @if (isPhysical) {
                  <label data-test-id="address-change-form-name-label"
                  for="primary_phone">{{convert('profileManagement.addressChangeForm.textName')}}</label>
                }
                <input data-test-id="address-change-form-name-input" type="text" class="form-control" [value]="organization?.oeName" formControlName="oeName" required
                  [class.is-invalid]="addressForm?.invalid && addressForm.controls?.oeName?.errors" />
                @if (addressForm?.invalid && addressForm.controls?.oeName?.errors) {
                  <div data-test-id="address-change-form-name-error" class="invalid-feedback">
                    {{convert('profileManagement.addressChangeForm.dealershipmMssageRequired')}}
                  </div>
                }
                <label data-test-id="address-change-form-address-line1-label" for="primary_phone">{{convert('profileManagement.addressChangeForm.addressline1')}}</label>
                <input data-test-id="address-change-form-address-line1-input" type="text" class="form-control" [value]="address?.addressLine1" formControlName="addressLine1"
                  required [class.is-invalid]="addressForm?.invalid && addressForm.controls?.addressLine1?.errors" />
                @if (addressForm?.invalid && addressForm.controls?.addressLine1?.errors) {
                  <div data-test-id="address-change-form-address-line1-error" class="invalid-feedback">
                    {{convert('profileManagement.addressChangeForm.addressMessageRequired')}}
                  </div>
                }
                <label data-test-id="address-change-form-address-line2-label" for="primary_phone">{{convert('profileManagement.addressChangeForm.addressline2')}}</label>
                <input data-test-id="address-change-form-address-line2-input" type="text" class="form-control" [value]="address?.addressLine2 || ''"
                  formControlName="addressLine2" />
                <label data-test-id="address-change-form-city-label" for="primary_phone">{{convert('profileManagement.addressChangeForm.cityLabel')}}</label>
                <input data-test-id="address-change-form-city-input" type="text" class="form-control" [value]="address?.city" formControlName="city" required
                  [class.is-invalid]="addressForm?.invalid && addressForm.controls?.city?.errors" />
                @if (addressForm?.invalid && addressForm.controls?.city?.errors) {
                  <div data-test-id="address-change-form-city-error" class="invalid-feedback">
                    {{convert('profileManagement.addressChangeForm.cityRequiredMessage')}}
                  </div>
                }
                <label data-test-id="address-change-form-zip-label" for="primary_phone">{{convert('profileManagement.addressChangeForm.zipcodeLabel')}}</label>
                <input data-test-id="address-change-form-zip-input" type="text" class="form-control" [value]="address?.zip" formControlName="zip" required
                  [class.is-invalid]="addressForm?.invalid && addressForm.controls?.zip?.errors" />
                @if (addressForm?.invalid && addressForm.controls?.zip?.errors?.required) {
                  <div data-test-id="address-change-form-zip-required-error" class="invalid-feedback">
                    {{convert('profileManagement.addressChangeForm.zipCodeRequiredMessage')}}
                  </div>
                }
                @if (addressForm.controls?.zip?.errors?.minlength) {
                  <div data-test-id="address-change-form-zip-minlength-error"
                    class="invalid-feedback">
                    {{convert('profileManagement.addressChangeForm.zipCodeValidation')}}
                  </div>
                }
                <label data-test-id="address-change-form-state-label" class="bookValue__label">{{convert('profileManagement.addressChangeForm.stateLabel')}}</label>
                @if (isCanadianTenantEnabled) {
                  <app-dropdown-select data-test-id="address-change-form-province-dropdown" #provincesDropdownSelect [items]="provinces"
                    (click)="updateStateOrProvince($event.target.dataset.value)"
                  [class.is-invalid]="addressForm?.invalid && addressForm.controls?.state?.errors"></app-dropdown-select>
                }
                @if (!isCanadianTenantEnabled) {
                  <app-dropdown-select data-test-id="address-change-form-state-dropdown" #statesDropdownSelect [items]="states"
                    (click)="updateStateOrProvince($event.target.dataset.value)"
                  [class.is-invalid]="addressForm?.invalid && addressForm.controls?.state?.errors"></app-dropdown-select>
                }
                @if (
                  addressForm.controls?.state?.errors ||
                  addressForm.controls?.state?.errors?.required ||
                  addressForm.controls?.state?.errors?.pattern
                  ) {
                  <div data-test-id="address-change-form-state-error" class="invalid-feedback dropdown">
                    {{convert('profileManagement.addressChangeForm.validStateRequired')}}
                  </div>
                }
                <div class="action-btns">
                  <button data-test-id="address-change-form-submit-btn" data-track-elem="button" data-track-name="Save" class="btn btn-primary bid-buttons me-2"
                    (click)="submit()"  [disabled]="addressForm?.invalid">
                    {{convert('common.labelSubmit')}}
                  </button>
                  <button data-test-id="address-change-form-cancel-btn" data-track-elem="button" data-track-name="Cancel" class="btn btn-link bid-buttons"
                    (click)="closed.emit()">
                    {{convert('common.btnCancel')}}
                  </button>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>
  </form>
</ng-container>
